<template>
    <div class="activity">
        <el-dialog title="创建活动" width="1300px" :visible="createDialogVisible" @close="closeDialog" @open="openDialog"
                   :close-on-click-modal="false" fullscreen>
            <el-form label-width="120px" :model="incubatorData" :rules="incubatorRules" ref="incubatorForm"
                     :validate-on-rule-change="false">
                <el-form-item label="活动模式：" prop="incubatorType">
                    <el-select v-model="incubatorData.incubatorType" placeholder="请选择活动模式" @change="incubatorTypeChange"
                               :disabled="incubatorDisable.incubatorType">
                        <el-option v-for="item in incubatorTypeEnum" :key="item.value" :label="item.name"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="语言：" prop="languageObj">
                    <el-checkbox-group v-model="incubatorData.languageObj" @change="$forceUpdate()"
                                       :disabled="incubatorDisable.lang">
                        <el-checkbox v-for="lang in languages" :label="lang.value" :key="lang.value">{{lang.label}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <h1>抢购设置</h1>
                <div style="border-bottom: 1px solid gainsboro"></div>
                <el-form-item label="名称：" prop="incubatorNameObj" style="margin-top: 20px">
                    <div v-for="lang in incubatorData.languageObj" :key="lang"
                         style="width: 200px;display: inline-block">
                        <el-input :value="incubatorData.incubatorNameObj[lang]" maxlength="100"
                                  :disabled="incubatorDisable.incubatorName"
                                  :rules="[{ required: true, message: '名称不能为空'}]"
                                  :placeholder="languagesObj[lang]+'名称 （最多100个字符）'"
                                  @change="incubatorNameObjChange(lang, $event)"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="活动币种：" prop="incubatorCoin">
                    <el-autocomplete class="inline-input" :disabled="incubatorDisable.incubatorCoin"
                                     v-model="incubatorData.incubatorCoin"
                                     :fetch-suggestions="querySearch"
                                     placeholder="请选择活动币种">
                        <i class="el-icon-close el-input__icon" slot="suffix"
                           @click="cleanIncubatorCoinCoin" style="cursor:pointer;">
                        </i>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="总量：" prop="totalAmount" style="display: inline-block"
                              :rules="[{pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/, message: '请输入数字'},{required: this.incubatorData.incubatorType != 'INVESTMENT', message: '请输入总量'}]"
                              v-show="incubatorData.incubatorType!='INVESTMENT'">
                    <el-input placeholder="请输入总量(前端实际显示数量)" maxlength="70" v-model="incubatorData.totalAmount"
                              :disabled="incubatorDisable.totalAmount"
                              style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="实际总量：" prop="actualTotalAmount" style="display: inline-block;margin-left: 30px"
                              :rules="[{pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/, message: '请输入数字'},{required: this.incubatorData.incubatorType != 'INVESTMENT', message: '请输入实际总量'}]"
                              v-show="incubatorData.incubatorType!='INVESTMENT'">
                    <el-input placeholder="请输入实际总量(我们实际拥有的数量)" maxlength="70" v-model="incubatorData.actualTotalAmount"
                              :disabled="incubatorDisable.actualTotalAmount"
                              style="width: 300px"></el-input>
                    <span style="color: red;padding-left: 50px">* 提示：总量必须大于等于实际总量</span>
                </el-form-item>
                <el-form-item label="价格：" prop="price"
                              :rules="[{pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/, message: '请输入数字'},{required: this.incubatorData.incubatorType != 'INVESTMENT', message: '请输入价格'}]"
                              v-show="incubatorData.incubatorType!='INVESTMENT'">
                    <el-input placeholder="请输入价格" maxlength="70" v-model="incubatorData.price" style="width: 300px"
                              :disabled="incubatorDisable.price">
                        <span slot="suffix">USDT</span>
                    </el-input>
                </el-form-item>
                <el-form-item label="公布时间：" prop="publicTime">
                    <el-date-picker value-format="timestamp" v-model="incubatorData.publicTime" style="width: 300px"
                                    :disabled="incubatorDisable.publicTime"
                                    type="datetime" placeholder="选择公布时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="开始时间：" prop="startTime">
                    <el-date-picker value-format="timestamp" v-model="incubatorData.startTime" style="width: 300px"
                                    :disabled="incubatorDisable.startTime"
                                    type="datetime" placeholder="选择开始时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间：" prop="endTime">
                    <el-date-picker value-format="timestamp" v-model="incubatorData.endTime" style="width: 300px"
                                    :disabled="incubatorDisable.endTime"
                                    type="datetime" placeholder="选择结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="分配模式：" prop="distributionType" v-show="incubatorData.incubatorType!='INVESTMENT'"
                              :rules=" [{required: this.incubatorData.incubatorType != 'INVESTMENT',message: '请选择分配模式'}]">
                    <el-select v-model="incubatorData.distributionType" placeholder="请选择分配模式" @change="$forceUpdate()"
                               :disabled="incubatorDisable.distributionType">
                        <el-option v-for="item in incubatorDistributionModelEnum" :key="item.value" :label="item.name"
                                   v-if="incubatorData.incubatorType!='GROUPBUYING'||item.value!='IMMEDIATE_DISTRIBUTION'"
                                   :value="item.value"></el-option>
                    </el-select>
                    <div v-if="incubatorData.distributionType=='LOCK_DISTRIBUTION'">
                        <div v-for="item in incubatorData.unlockingTimeObj" :key="item.id" style="margin-top: 10px">
                            <el-date-picker value-format="timestamp" v-model="item.unlockTime" style="width: 300px"
                                            :disabled="incubatorDisable.distributionType"
                                            type="datetime" placeholder="选择解锁时间"></el-date-picker>
                            <el-input placeholder="请输入解锁比列（0<x<=1）" maxlength="70" v-model="item.scale"
                                      :disabled="incubatorDisable.distributionType"
                                      style="width: 300px"></el-input>
                            <el-button style="margin-left: 30px" icon="el-icon-minus" type="danger"
                                       :disabled="incubatorDisable.distributionType"
                                       @click="deleteUnlockingTimeObj(item.id)"></el-button>
                        </div>
                        <el-button style="margin-left: 0px;margin-top: 10px" icon="el-icon-plus" type="primary"
                                   :disabled="incubatorDisable.distributionType"
                                   @click="addUnlockingTimeObj"></el-button>
                    </div>
                </el-form-item>
                <el-form-item label="首发：" prop="firstRound" style="display: inline-block">
                    <el-switch v-model="incubatorData.firstRound.conditionStatus" active-color="#13ce66"
                               :disabled="incubatorDisable.firstRound"
                               inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item label="打折：" prop="discount" style="display: inline-block;margin-left: 30px"
                              v-show="incubatorData.incubatorType!='INVESTMENT'">
                    <el-switch v-model="incubatorData.discount.conditionStatus" active-color="#13ce66"
                               :disabled="incubatorDisable.discount"
                               inactive-color="#ff4949"></el-switch>
                    <span style="color: red;padding-left: 50px">* 提示：首发和打折只能开启一个</span>
                </el-form-item>

                <h1>支付设置</h1>
                <div style="border-bottom: 1px solid gainsboro"></div>
                <el-form-item label="精度：" prop="scale" style="margin-top: 20px">
                    <el-input placeholder="请输入精度" maxlength="70" v-model="incubatorData.scale"
                              :disabled="incubatorDisable.scale" style="width: 300px">
                    </el-input>
                </el-form-item>
                <el-form-item label="单笔最小：" prop="singleMin" style="margin-top: 20px">
                    <el-input placeholder="请输入单笔最小" maxlength="70" v-model="incubatorData.singleMin"
                              :disabled="incubatorDisable.singleMin"
                              style="width: 300px">
                        <span slot="suffix">{{incubatorData.incubatorType=='INVESTMENT'?incubatorData.paymentCoinObj[0]:incubatorData.incubatorCoin}}</span>
                    </el-input>
                </el-form-item>
                <el-form-item label="单笔最大：" prop="singleMax">
                    <el-input placeholder="请输入单笔最大" maxlength="70" v-model="incubatorData.singleMax"
                              :disabled="incubatorDisable.singleMax"
                              style="width: 300px">
                        <span slot="suffix">{{incubatorData.incubatorType=='INVESTMENT'?incubatorData.paymentCoinObj[0]:incubatorData.incubatorCoin}}</span>
                    </el-input>
                </el-form-item>
                <el-form-item label="支付币种：" prop="paymentCoinObj">
                    <el-select v-model="incubatorData.paymentCoinObj" filterable multiple
                               :multiple-limit="incubatorData.incubatorType=='INVESTMENT'?1:0" placeholder="请选择支付币种"
                               :disabled="incubatorDisable.paymentCoin"
                               @change="$forceUpdate()"
                               style="width: 50%">
                        <el-option v-for="item in coinTypes" :key="item+'p'" :label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="优惠币种：" prop="discountCoinObj" v-show="incubatorData.incubatorType!='INVESTMENT'">
                    <el-select v-model="incubatorData.discountCoinObj" filterable multiple placeholder="请选择支付币种"
                               :disabled="incubatorDisable.discountCoin"
                               @change="$forceUpdate()"
                               style="width: 50%">
                        <el-option v-for="item in coinTypes" :key="item+'d'" :label="item" :value="item"></el-option>
                    </el-select>
                    <el-input placeholder="请输入折扣价格" maxlength="70" v-model="incubatorData.discountNum"
                              :disabled="incubatorDisable.discountCoin"
                              style="width: 300px">
                        <span slot="suffix">USDT</span>
                    </el-input>
                </el-form-item>
                <el-form-item label="多次购买：" prop="manyTimes.conditionStatus">
                    <el-switch v-model="incubatorData.manyTimes.conditionStatus" active-color="#13ce66"
                               :disabled="incubatorDisable.manyTimes"
                               inactive-color="#ff4949"></el-switch>
                    <span style="color: red;padding-left: 50px">* 提示：开启后用户能参与多次购买，直到达到最大限额</span>
                </el-form-item>
                <el-form-item label="BKK持仓优惠：" prop="bkkDiscount.conditionStatus"
                              v-show="incubatorData.incubatorType!='INVESTMENT'">
                    <el-switch v-model="incubatorData.bkkDiscount.conditionStatus" active-color="#13ce66"
                               :disabled="incubatorDisable.bkkDiscount"
                               inactive-color="#ff4949"></el-switch>
                    <div v-if="incubatorData.bkkDiscount.conditionStatus" style="margin-left: 60px">
                        <div v-for="item in incubatorData.bkkDiscountObj" :key="item.id" style="margin-top: 10px">
                            <el-input placeholder="支付币种价格" maxlength="70" v-model="item.num"
                                      :disabled="incubatorDisable.bkkDiscount"
                                      style="width: 300px">
                                <span slot="prefix" style="display: inline-block">持仓>=</span>
                                <span slot="suffix">BKK</span>
                            </el-input>
                            <el-input placeholder="支付币种价格" maxlength="70" v-model="item.payCoinPrice"
                                      :disabled="incubatorDisable.bkkDiscount"
                                      style="width: 250px">
                                <span slot="suffix">USDT</span>
                            </el-input>
                            <el-input placeholder="优惠币种价格" maxlength="70" v-model="item.discountCounPrice"
                                      :disabled="incubatorDisable.bkkDiscount"
                                      style="width: 250px">
                                <span slot="suffix">USDT</span>
                            </el-input>
                            <el-button style="margin-left: 30px" icon="el-icon-minus" type="danger"
                                       :disabled="incubatorDisable.bkkDiscount"
                                       @click="deleteBkkDiscountObj(item.id)"></el-button>
                        </div>
                        <el-button style="margin-left: 0px;margin-top: 10px" icon="el-icon-plus" type="primary"
                                   :disabled="incubatorDisable.bkkDiscount"
                                   @click="addBkkDiscountObj"></el-button>
                    </div>
                </el-form-item>

                <h1>抢购限制</h1>
                <div style="border-bottom: 1px solid gainsboro"></div>
                <el-form-item label="持仓限制：" prop="positionLimit.conditionStatus" style="margin-top: 20px">
                    <el-switch v-model="incubatorData.positionLimit.conditionStatus" active-color="#13ce66"
                               :disabled="incubatorDisable.positionLimit"
                               inactive-color="#ff4949"></el-switch>
                    <div v-if="incubatorData.positionLimit.conditionStatus"
                         style="margin-left: 20px">

                        <div v-for="itemLimit in incubatorData.positionLimitObj" :key="itemLimit.id"
                             style="margin-top: 10px">
                            <el-select v-model="itemLimit.type" placeholder="请选择持仓类型"
                                       :disabled="incubatorDisable.positionLimit"
                                       @change="$forceUpdate()"
                                       style="width: 150px">
                                <el-option v-for="item in incubatorPositionTypeEnum" :key="item.value"
                                           :label="item.label"
                                           :value="item.value"></el-option>
                            </el-select>
                            <el-select v-model="itemLimit.coinTypes" filterable
                                       :disabled="incubatorDisable.positionLimit"
                                       @change="$forceUpdate()"
                                       placeholder="请选择持仓币种" style="width:200px">
                                <el-option v-for="item in coinTypes" :key="item+'po'" :label="item"
                                           :value="item"></el-option>
                            </el-select>
                            <el-date-picker v-model="itemLimit.dataArry"
                                            :disabled="incubatorDisable.positionLimit"
                                            v-if="itemLimit.type!='CURRENT_POSITION'"
                                            type="datetimerange" range-separator="至"
                                            start-placeholder="开始时间" end-placeholder="结束时间" value-format="timestamp"
                                            @change="positionLimitDataArryChange(itemLimit)"></el-date-picker>
                            <el-input placeholder="持仓数量" maxlength="70" v-model="itemLimit.num"
                                      :disabled="incubatorDisable.positionLimit"
                                      style="width: 300px">
                                <span slot="prefix" style="display: inline-block">持仓>=</span>
                            </el-input>
                            <el-button style="margin-left: 30px" icon="el-icon-minus" type="danger"
                                       :disabled="incubatorDisable.positionLimit"
                                       @click="deletePositionLimitObj(itemLimit.id)"></el-button>
                        </div>
                        <el-button style="margin-left: 0px;margin-top: 10px" icon="el-icon-plus" type="primary"
                                   :disabled="incubatorDisable.positionLimit"
                                   @click="addPositionLimitObj"></el-button>
                    </div>
                </el-form-item>
                <el-form-item label="成交额限制：" prop="turnoverLimit.conditionStatus" style="margin-top: 20px">
                    <el-switch v-model="incubatorData.turnoverLimit.conditionStatus" active-color="#13ce66"
                               :disabled="incubatorDisable.turnoverLimit"
                               inactive-color="#ff4949" style="margin-right: 20px"></el-switch>
                    <div v-if="incubatorData.turnoverLimit.conditionStatus && incubatorData.turnoverLimitObj.type=='TURNOVER'"
                         v-for="lang in incubatorData.languageObj"
                         :key="lang" style="width: 200px;display: inline-block">
                        <el-input v-model="incubatorData.turnoverLimitObj.name[lang]" maxlength="100"
                                  :disabled="incubatorDisable.turnoverLimit"
                                  :rules="[{ required: true, message: '名称不能为空'}]"
                                  :placeholder="languagesObj[lang]+'名称 （最多100个字符）'"></el-input>
                    </div>
                    <div v-if="incubatorData.turnoverLimit.conditionStatus" style="margin-left: 60px;margin-top: 10px">
                        <el-select v-model="incubatorData.turnoverLimitObj.type" placeholder="请选择成交额或总手续费限制"
                                   @change="$forceUpdate()" :disabled="incubatorDisable.turnoverLimit"
                                   style="width: 150px">
                            <el-option v-for="item in incubatorTurnoverTypeEnum" :key="item.value" :label="item.label"
                                       :value="item.value"></el-option>
                        </el-select>
                        <el-select v-model="incubatorData.turnoverLimitObj.pairs" filterable multiple
                                   v-if="incubatorData.turnoverLimitObj.type=='TURNOVER'"
                                   @change="$forceUpdate()" :disabled="incubatorDisable.turnoverLimit"
                                   placeholder="请选择交易对" style="width:700px">
                            <el-option v-for="item in pairTypes" :key="item+'pa'" :label="item"
                                       :value="item"></el-option>
                        </el-select>
                        <el-date-picker v-model="incubatorData.turnoverLimitObj.dataArry"
                                        :disabled="incubatorDisable.turnoverLimit"
                                        type="datetimerange" range-separator="至"
                                        start-placeholder="开始时间" end-placeholder="结束时间" value-format="timestamp"
                                        @change="turnoverLimitDataArryChange"></el-date-picker>
                        <el-input :placeholder="incubatorData.turnoverLimitObj.type=='TURNOVER'?'成交额':'手续费'"
                                  maxlength="70" v-model="incubatorData.turnoverLimitObj.num"
                                  :disabled="incubatorDisable.turnoverLimit"
                                  style="width: 300px">
                            <span slot="prefix" style="display: inline-block">{{incubatorData.turnoverLimitObj.type=='TURNOVER'?'成交额':'手续费'}}>=</span>
                            <span slot="suffix">USDT</span>
                        </el-input>
                    </div>
                </el-form-item>
                <el-form-item label="锁仓限制：" prop="lockLimit.conditionStatus" style="margin-top: 20px">
                    <el-switch v-model="incubatorData.lockLimit.conditionStatus" active-color="#13ce66"
                               :disabled="incubatorDisable.lockLimit"
                               inactive-color="#ff4949" style="margin-right: 20px"></el-switch>
                    <div v-if="incubatorData.lockLimit.conditionStatus" style="margin-left: 60px">
                        <div v-for="item in incubatorData.lockLimitObj" :key="item.id" style="margin-top: 10px">
                            <el-autocomplete class="inline-input" :disabled="incubatorDisable.lockLimit"
                                             v-model="item.lockCoin"
                                             :fetch-suggestions="querySearch"
                                             placeholder="请选择锁仓币种">
                                <i class="el-icon-close el-input__icon" slot="suffix"
                                   @click="cleanLockLimitCoin(item)" style="cursor:pointer;">
                                </i>
                            </el-autocomplete>
                            <el-input placeholder="锁仓数量" maxlength="70" v-model="item.lockAmount"
                                      :disabled="incubatorDisable.lockLimit"
                                      style="width: 250px">
                            </el-input>
                            <el-date-picker value-format="timestamp" v-model="item.unlockTime" style="width: 300px"
                                            :disabled="incubatorDisable.lockLimit"
                                            type="datetime" placeholder="解锁时间">
                            </el-date-picker>
                            <el-button style="margin-left: 30px" icon="el-icon-minus" type="danger"
                                       :disabled="incubatorDisable.lockLimit"
                                       @click="deleteLockLimitObj(item.id)"></el-button>
                        </div>
                        <el-button style="margin-left: 0px;margin-top: 10px" icon="el-icon-plus" type="primary"
                                   :disabled="incubatorDisable.lockLimit"
                                   @click="addLockLimitObj"></el-button>
                    </div>
                </el-form-item>

                <h1>用户限制</h1>
                <div style="border-bottom: 1px solid gainsboro"></div>
                <el-form-item label="实名限制：" prop="kyc.conditionStatus" style="margin-top: 20px">
                    <el-switch v-model="incubatorData.kyc.conditionStatus" active-color="#13ce66"
                               :disabled="incubatorDisable.kyc"
                               @change="changeKyc"
                               inactive-color="#ff4949" style="margin-right: 20px"></el-switch>
                    <el-radio-group v-model="incubatorData.kyc.conditionParams" v-if="incubatorData.kyc.conditionStatus" :disabled="incubatorDisable.kyc">
                      <el-radio label="1">基础实名</el-radio>
                      <el-radio label="2">高级实名</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="地区限制：" prop="area.conditionStatus" style="margin-top: 20px">
                    <el-switch v-model="incubatorData.area.conditionStatus" active-color="#13ce66"
                               :disabled="incubatorDisable.area"
                               inactive-color="#ff4949" style="margin-right: 20px"></el-switch>
                    <el-select v-model="incubatorData.areaObj" filterable multiple @change="$forceUpdate()"
                               :disabled="incubatorDisable.area"
                               v-if="incubatorData.area.conditionStatus"
                               placeholder="请选择地区" style="width:800px">
                        <el-option v-for="item in country" :key="item.id+'a'" :label="item.zh"
                                   :value="item.code"></el-option>
                    </el-select>
                    <span style="color: red;padding-left: 50px">* 提示：被选中的地区不能参与</span>
                </el-form-item>
                <el-form-item label="表单限制：" prop="formData.conditionStatus" style="margin-top: 20px">
                    <el-switch v-model="incubatorData.formData.conditionStatus" active-color="#13ce66"
                               :disabled="incubatorDisable.formData"
                               inactive-color="#ff4949" style="margin-right: 20px"></el-switch>
                    <div v-if="incubatorData.formData.conditionStatus" v-for="lang in incubatorData.languageObj"
                         :key="lang" style="display: inline-block;margin-right: 10px">
                        <FormData v-model="incubatorData.formDataObj[lang]" :fName="languagesObj[lang]"
                                  :disabled="incubatorDisable.formData"></FormData>
                    </div>
                </el-form-item>
                <el-form-item label="协议限制：" prop="agreementData.conditionStatus" style="margin-top: 20px">
                    <el-switch v-model="incubatorData.agreementData.conditionStatus" active-color="#13ce66"
                               :disabled="incubatorDisable.agreementData"
                               inactive-color="#ff4949" style="margin-right: 20px"></el-switch>
                    <div v-if="incubatorData.agreementData.conditionStatus" v-for="lang in incubatorData.languageObj"
                         :key="lang" style="display: inline-block;margin-right: 10px">
                        <AgreementData v-model="incubatorData.agreementDataObj[lang]"
                                       :disabled="incubatorDisable.agreementData"
                                       :fName="languagesObj[lang]"></AgreementData>
                    </div>
                </el-form-item>

                <h1>项目信息</h1>
                <div style="border-bottom: 1px solid gainsboro"></div>
                <el-form-item label="白皮书：" prop="projectDetailObj.whitePaper" style="margin-top: 20px">
                    <el-input placeholder="请输入白皮书地址" maxlength="500" v-model="incubatorData.projectDetailObj.whitePaper"
                              :disabled="incubatorDisable.website"
                              style="width: 700px"></el-input>
                </el-form-item>
                <el-form-item label="官网：" prop="projectDetailObj.website">
                    <el-input placeholder="请输入官网地址" maxlength="500" v-model="incubatorData.projectDetailObj.website"
                              :disabled="incubatorDisable.website"
                              style="width: 700px"></el-input>
                </el-form-item>
                <el-form-item label="FAQ：" prop="projectDetailObj.faq">
                    <el-input placeholder="请输入FAQ链接" maxlength="500" v-model="incubatorData.projectDetailObj.faq"
                              :disabled="incubatorDisable.faq"
                              style="width: 700px"></el-input>
                </el-form-item>
                <el-form-item label="Telegram：" prop="projectDetailObj.telegram">
                    <el-input placeholder="请输入Telegram链接" maxlength="500" :disabled="incubatorDisable.telegram"
                              v-model="incubatorData.projectDetailObj.telegram"
                              style="width: 700px"></el-input>
                </el-form-item>
                <el-form-item label="Twitter：" prop="projectDetailObj.twitter">
                    <el-input placeholder="请输入Twitter链接" maxlength="500" :disabled="incubatorDisable.twitter"
                              v-model="incubatorData.projectDetailObj.twitter"
                              style="width: 700px"></el-input>
                </el-form-item>
                <el-form-item label="Medium：" prop="projectDetailObj.medium">
                    <el-input placeholder="请输入Medium链接" maxlength="500" v-model="incubatorData.projectDetailObj.medium"
                              :disabled="incubatorDisable.medium"
                              style="width: 700px"></el-input>
                </el-form-item>
                <el-form-item label="Linked：" prop="projectDetailObj.linked">
                    <el-input placeholder="请输入Linked链接" maxlength="500" v-model="incubatorData.projectDetailObj.linked"
                              :disabled="incubatorDisable.linked"
                              style="width: 700px"></el-input>
                </el-form-item>
                <el-form-item label="发行总量：" prop="projectDetailObj.totalIssue">
                    <el-input placeholder="请输入项目发行总量" maxlength="100" :disabled="incubatorDisable.totalIssue"
                              v-model="incubatorData.projectDetailObj.totalIssue"
                              style="width: 700px"></el-input>
                </el-form-item>
                <el-form-item label="流通量：" prop="projectDetailObj.circulation">
                    <el-input placeholder="请输入项目流通量" maxlength="100" :disabled="incubatorDisable.circulation"
                              v-model="incubatorData.projectDetailObj.circulation"
                              style="width: 700px"></el-input>
                </el-form-item>
                <el-form-item label="代币类型：" prop="projectDetailObj.tokenType" style="margin-top: 20px">
                    <div v-for="lang in incubatorData.languageObj" :key="lang"
                         style="width: 200px;display: inline-block">
                        <el-input v-model="incubatorData.projectDetailObj.tokenType[lang]" maxlength="100"
                                  :disabled="incubatorDisable.tokenType"
                                  :placeholder="languagesObj[lang]+'代币类型 （最多100个字符）'"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="项目简介：" prop="projectDetailObj.incubatorSynopsis">
                    <div v-for="lang in incubatorData.languageObj" :key="lang"
                         style="margin-right: 10px;margin-bottom: 10px">
                        <el-input v-model="incubatorData.projectDetailObj.incubatorSynopsis[lang]" type="textarea"
                                  :disabled="incubatorDisable.incubatorSynopsis"
                                  :rows="2" :placeholder="'请输入项目简介（'+languagesObj[lang]+'）'"
                                  style="width:80%"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="项目详情：" prop="projectDetailObj.projectDetail" style="margin-top: 20px">
                    <div v-for="lang in incubatorData.languageObj" :key="lang"
                         style="display: inline-block;margin-right: 10px;vertical-align: top;width: 360px;overflow: hidden">
                        <span>{{languagesObj[lang]}}</span>
                        <uploadMoulde :value="incubatorData.projectDetailObj.projectDetail[lang]"
                                      :disabled="incubatorDisable.projectDetail"
                                      :limitNumber="1"
                                      v-on:input="getSucessInfo(lang,$event)"
                                      ref="childUpload"></uploadMoulde>
                    </div>
                </el-form-item>
                <el-form-item label="Banner：" prop="projectDetailObj.banner" style="margin-top: 20px">
                    <div v-for="lang in incubatorData.languageObj" :key="lang"
                         style="display: inline-block;margin-right: 10px;vertical-align: top;width: 360px;overflow: hidden">
                        <span>{{languagesObj[lang]}}</span>
                        <uploadMoulde :value="incubatorData.projectDetailObj.banner[lang]"
                                      :disabled="incubatorDisable.banner"
                                      :limitNumber="1"
                                      v-on:input="getSucessInfoBananr(lang,$event)"
                                      ref="childUpload"></uploadMoulde>
                    </div>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <div style="width: 100%;text-align: center">
                    <el-button @click="toggleCreateDialogVisible(false)">取消</el-button>
                    <el-button type="danger" @click="handleSave()">保存</el-button>
                </div>
             </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';
    import {mapState, mapMutations, mapActions, mapGetters} from "vuex";
    import {
        INCUBATOR_TYPE_ENUM,
        INCUBATOR_STATUS_ENUM,
        INCUBATOR_DISTRIBUTION_MODEL_ENUM,
        INCUBATOR_POSITION_TYPE_ENUM,
        INCUBATOR_TURNOVER_TYPE_ENUM
    } from "../constants";
    import LANGUAGES from "../../../../common/languages_code";
    import uploadMoulde from "../../../../components/upload/indexLimit.vue";
    import FormData from "./formData";
    import AgreementData from "./agreementData";

    export default {
        name: "CreateIncubator",
        components: {
            uploadMoulde,
            FormData,
            AgreementData,
        },
        data() {
            return {
                incubatorData: {
                    id: "", //记录id
                    lang: "", //支持语言,数据格式:[zh,..]
                    incubatorType: "SECKILL", //活动模式
                    distributionType: "", //分配模式
                    incubatorName: "", //名称,数据格式:{zh:'',...}
                    incubatorCoin: "", //币种
                    paymentCoin: "", //支付币种,数据格式:[BTC,..]
                    discountCoin: "", //优惠币种,数据格式:[BTC,..]
                    totalAmount: "", //总量
                    actualTotalAmount: "", //实际总量
                    nowAmount: "", //当前总量（已申购）
                    scale: "", //精度
                    price: "", //价格
                    singleMin: "", //单笔最小
                    singleMax: "", //单笔最大
                    discountNum: "", //优惠折扣
                    state: "", //状态
                    startTime: "", //开始时间
                    endTime: "", //结束时间
                    publicTime: "", //公布时间
                    unlockingTime: "", //解锁时间,数据格式:[{id:1,unlockTime:1000000,scale:0.8},{},..]
                    publishTime: "", //发布时间
                    projectDetail: {
                        id: "",
                        incubatorId: "",
                        conditionType: "PROJECT_DETAIL",
                        conditionStatus: true,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, // projectDetail: {incubatorSynopsis: {}, //简介 banner: {}, //banner projectDetail: {}, //项目详情 circulation: '', //流通量 tokenType: '', //代币类型 totalIssue: '', //发行总量 linked: '', //Linked链接 medium: '', //Medium链接 twitter: '', //Twitter链接 telegram: '', //Telegram链接 faq: '', //FAQ链接 website: '', //官网链接 whitePaper: '' //白皮书链接
                    firstRound: {
                        id: "",
                        incubatorId: "",
                        conditionType: "FIRST_ROUND",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //首发
                    discount: {
                        id: "",
                        incubatorId: "",
                        conditionType: "DISCOUNT",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //打折
                    manyTimes: {
                        id: "",
                        incubatorId: "",
                        conditionType: "MANY_TIMES",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //多次购买
                    bkkDiscount: {
                        id: "",
                        incubatorId: "",
                        conditionType: "BKK_DISCOUNT",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //BKK持仓优惠,数据格式:[{num:2000,payCoinPrice:0.5,discountCounPrice:0.6},{},..]
                    positionLimit: {
                        id: "",
                        incubatorId: "",
                        conditionType: "POSITION_LIMIT",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //持仓限制,数据格式:[{type:'',coinType:'BTC',startTime:10000,endTime:20000,num:1000},...]
                    turnoverLimit: {
                        id: "",
                        incubatorId: "",
                        conditionType: "TURNOVER_LIMIT",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //成交额限制,数据格式:{type:'',pairs:['BTC_USDT',..],name:'',startTime:10000,endTime:20000,num:1000}
                    lockLimit: {
                        id: "",
                        incubatorId: "",
                        conditionType: "LOCK_LIMIT",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //锁仓限制,数据格式:[{unlockTime,'',lockCoin:'BTC',lockAmount:2000},....]
                    kyc: {
                        id: "",
                        incubatorId: "",
                        conditionType: "KYC",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //实名验证
                    area: {
                        id: "",
                        incubatorId: "",
                        conditionType: "AREA",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //地区验证,数据格式:[{areaCode:1010,areaName:{zh:'中国'}},...]
                    formData: {
                        id: "",
                        incubatorId: "",
                        conditionType: "FORM_DATA",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //表单验证,数据格式:{name:'',desc:'',formData:[{title:'',must:true,answerType:'',option:[{tag:'',content:''},....]},...]}
                    agreementData: {
                        id: "",
                        incubatorId: "",
                        conditionType: "AGREEMENT_DATA",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //协议验证,数据格式:{name:'',content:''}
                    //下面是对象参数用于json互转
                    languageObj: ["zh"],
                    incubatorNameObj: {},
                    paymentCoinObj: [],
                    discountCoinObj: [],
                    unlockingTimeObj: [{id: (new Date()).getTime(), unlockTime: "", scale: ""}],
                    projectDetailObj: {
                        incubatorSynopsis: {zh: ""},
                        banner: {zh: ""},
                        projectDetail: {zh: ""},
                        circulation: '',
                        tokenType: {zh: ""},
                        totalIssue: '',
                        linked: '',
                        medium: '',
                        twitter: '',
                        telegram: '',
                        faq: '',
                        website: '',
                        whitePaper: ''
                    },
                    bkkDiscountObj: [{id: (new Date()).getTime(), num: "", payCoinPrice: "", discountCounPrice: ""}],
                    positionLimitObj: [{
                        id: (new Date()).getTime(),
                        type: "AVERAGE_DAILY_POSITION",
                        coinTypes: "",
                        startTime: "",
                        endTime: "",
                        num: "",
                        dataArry: []
                    }],
                    turnoverLimitObj: {
                        type: "TURNOVER",
                        pairs: [],
                        name: {zh: ""},
                        startTime: "",
                        endTime: "",
                        num: "",
                        dataArry: []
                    },
                    lockLimitObj: [{id: (new Date()).getTime(), lockCoin: "", lockAmount: "", unlockTime: ""}],
                    areaObj: [],
                    formDataObj: {
                        zh: {
                            name: "",
                            desc: "",
                            formData: [{
                                id: (new Date()).getTime(),
                                title: "",
                                must: false,
                                answerType: "",
                                userAnswer: "",
                                correctAnswer: "",
                                option: [{id: (new Date()).getTime(), tag: "", content: ""}]
                            }]
                        }
                    },
                    agreementDataObj: {
                        zh: {name: "", content: ""}
                    }
                },
                incubatorRules: {
                    "incubatorType": [{required: true, message: "请选择活动模式"}],
                    "languageObj": [{required: true, message: "请选择语言"}],
                    "incubatorNameObj": [{required: true, message: "请选输入活动名称"}],
                    "incubatorCoin": [{required: true, message: "请选择活动币种"}],
                    "startTime": [{required: true, message: '请设置开始时间'}],
                    "endTime": [{required: true, message: '请设置结束时间'}],
                    "publicTime": [{required: true, message: '请设置公布时间'}],
                    "singleMin": [
                        {pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/, message: "请输入数字"},
                        {required: true, message: '请输入单笔最小数量'}
                    ],
                    "scale": [
                        {pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/, message: "请输入数字"},
                        {required: true, message: '请输入精度'}
                    ],
                    "singleMax": [
                        {pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/, message: "请输入数字"},
                        {required: true, message: '请输入单笔最大数量'}
                    ],
                    "paymentCoinObj": [{required: true, message: '请设置支付币种'}],
                    // "projectDetailObj.totalIssue": [{required: true, message: '请填写发行总量'}],
                    // "projectDetailObj.circulation": [{required: true, message: '请填写流通量'}],
                    // "projectDetailObj.tokenType": [{required: true, message: '请选择代币类型'}],
                    // "projectDetailObj.incubatorSynopsis": [{required: true, message: '请填写项目简介'}],
                    // "projectDetailObj.projectDetail": [{required: true, message: '请填上传项目详情'}],
                    "projectDetailObj.banner": [{required: true, message: '请填上传项目Banner'}],
                },
                incubatorDisable: {
                    lang: false, //支持语言
                    incubatorType: false, //活动模式
                    distributionType: true, //分配模式
                    incubatorName: false, //名称
                    incubatorCoin: false, //币种
                    paymentCoin: false, //支付币种
                    discountCoin: false, //优惠币种
                    startTime: false, //开始时间
                    endTime: false, //结束时间
                    totalAmount: false, //总量
                    actualTotalAmount: false, //实际总量
                    nowAmount: false, //当前总量（已申购）
                    scale: false, //精度
                    price: false, //价格
                    singleMin: false, //单笔最小
                    singleMax: false, //单笔最大
                    discountNum: false, //优惠折扣
                    publicTime: false, //公布时间
                    unlockingTime: false, //解锁时间
                    firstRound: false, //首发
                    discount: false, //打折
                    manyTimes: false, //多次购买
                    bkkDiscount: false, //BKK持仓优惠
                    positionLimit: false, //持仓限制
                    turnoverLimit: false, //成交额限制
                    lockLimit: false, //锁仓限制
                    kyc: false, //实名验证
                    area: false, //地区验证
                    formData: false, //表单验证
                    agreementData: false, //协议验证
                    incubatorSynopsis: false,  //简介
                    banner: false, //banner
                    projectDetail: false, //项目详情
                    circulation: false, //流通量
                    tokenType: false,  //代币类型
                    totalIssue: false, //发行总量
                    linked: false, //Linked链接
                    medium: false, //Medium链接
                    twitter: false, //Twitter链接
                    telegram: false, //Telegram链接
                    faq: false, //FAQ链接
                    website: false, //官网链接
                    whitePaper: false //白皮书链接
                },
                languages: Object.keys(LANGUAGES).map(lang => ({
                    label: LANGUAGES[lang],
                    value: lang
                })),
                languagesObj: LANGUAGES,
                incubatorTypeEnum: INCUBATOR_TYPE_ENUM,
                incubatorDistributionModelEnum: INCUBATOR_DISTRIBUTION_MODEL_ENUM,
                incubatorPositionTypeEnum: INCUBATOR_POSITION_TYPE_ENUM,
                incubatorTurnoverTypeEnum: INCUBATOR_TURNOVER_TYPE_ENUM,
            }
        },
        computed: {
            ...mapState("IncubatorManage", ["createDialogVisible", "currId", "coinTypes", "pairTypes", "country", "chain"])
        },
        methods: {
            ...mapMutations("IncubatorManage", ["toggleCreateDialogVisible"]),
            ...mapActions("IncubatorManage", ["setCurrId"]),
            incubatorTypeChange() {
                this.incubatorData.distributionType = "";
                this.$forceUpdate();
            },
            incubatorNameObjChange(lang, value) {
                this.incubatorData.incubatorNameObj[lang] = value;
                this.incubatorData.incubatorName = JSON.stringify(this.incubatorData.incubatorNameObj);
                this.$forceUpdate();
            },
            positionLimitDataArryChange(item) {
                item.startTime = item.dataArry != null ? item.dataArry[0] : "";
                item.endTime = item.dataArry != null ? item.dataArry[1] : "";
                this.$forceUpdate();
            },
            turnoverLimitDataArryChange() {
                this.incubatorData.turnoverLimitObj.startTime = this.incubatorData.turnoverLimitObj.dataArry != null ? this.incubatorData.turnoverLimitObj.dataArry[0] : "";
                this.incubatorData.turnoverLimitObj.endTime = this.incubatorData.turnoverLimitObj.dataArry != null ? this.incubatorData.turnoverLimitObj.dataArry[1] : "";
                this.$forceUpdate();
            },
            handleSave() {
                this.$refs['incubatorForm'].validate(valid => {
                    if (valid) {
                        this.buildData(this.incubatorData);
                        api.addOrUpdateIncubator(this.incubatorData).then(() => {
                            this.$message.success("操作成功！");
                            this.toggleCreateDialogVisible(false);
                            this.$emit("refresh");
                        });
                    }
                });
            },
            buildData(data) {
                this.incubatorData.lang = this.incubatorData.languageObj ? JSON.stringify(this.incubatorData.languageObj) : "[]";
                this.incubatorData.incubatorName = this.incubatorData.incubatorNameObj ? JSON.stringify(this.incubatorData.incubatorNameObj) : "{}";
                this.incubatorData.paymentCoin = this.incubatorData.paymentCoinObj ? JSON.stringify(this.incubatorData.paymentCoinObj) : "[]";
                this.incubatorData.discountCoin = this.incubatorData.discountCoinObj ? JSON.stringify(this.incubatorData.discountCoinObj) : "[]";
                this.incubatorData.unlockingTime = this.incubatorData.unlockingTimeObj ? JSON.stringify(this.incubatorData.unlockingTimeObj) : "[]";
                this.incubatorData.projectDetail.conditionParams = this.incubatorData.projectDetailObj ? JSON.stringify(this.incubatorData.projectDetailObj) : "{}";
                this.incubatorData.bkkDiscount.conditionParams = this.incubatorData.bkkDiscountObj ? JSON.stringify(this.incubatorData.bkkDiscountObj) : "[]";
                this.incubatorData.positionLimit.conditionParams = this.incubatorData.positionLimitObj ? JSON.stringify(this.incubatorData.positionLimitObj) : "[]";
                this.incubatorData.turnoverLimit.conditionParams = this.incubatorData.turnoverLimitObj ? JSON.stringify(this.incubatorData.turnoverLimitObj) : "{}";
                this.incubatorData.lockLimit.conditionParams = this.incubatorData.lockLimitObj ? JSON.stringify(this.incubatorData.lockLimitObj) : "[]";
                this.incubatorData.area.conditionParams = this.incubatorData.areaObj ? this.bulidCountry(this.incubatorData.areaObj) : "[]";
                this.incubatorData.formData.conditionParams = this.incubatorData.formDataObj ? JSON.stringify(this.incubatorData.formDataObj) : "{}";
                this.incubatorData.agreementData.conditionParams = this.incubatorData.agreementDataObj ? JSON.stringify(this.incubatorData.agreementDataObj) : "{}";
            },
            bulidCountry(areas) {
                let c = [];
                for (let i = 0; i < areas.length; i++) {
                    for (let j = 0; j < this.country.length; j++) {
                        if (this.country[j].code === areas[i]) {
                            c.push({
                                areaCode: this.country[j].code,
                                areaName: {zh: this.country[j].zh, en: this.country[j].en}
                            });
                        }
                    }
                }
                return JSON.stringify(c);
            },
            getCountryCode(areas) {
                let c = [];
                for (let i = 0; i < areas.length; i++) {
                    c.push(areas[i].areaCode);
                }
                return c;
            },
            openDialog() {
                this.initData();
                if (this.currId != null) {
                    api.getIncubatorDetail({id: this.currId}).then(({data}) => {
                        this.parseData(data);
                        this.initStatus(data.state);
                    });
                } else {
                    this.$refs["incubatorForm"] ? this.$refs["incubatorForm"].resetFields() : "";
                    this.initStatus();
                }
            },
            initStatus(status) {
                switch (status) {
                    case 3: //已结束(等待放币)
                    case 4: //核算中
                    case 5: //核算完
                    case 6: //已完成
                        this.incubatorDisable = {
                            lang: true, //支持语言
                            incubatorType: true, //活动模式
                            distributionType: true, //分配模式
                            incubatorName: false, //名称
                            incubatorCoin: true, //币种
                            paymentCoin: true, //支付币种
                            discountCoin: true, //优惠币种
                            startTime: true, //开始时间
                            endTime: true, //结束时间
                            totalAmount: true, //总量
                            actualTotalAmount: true, //实际总量
                            price: true, //价格
                            scale: false, //精度
                            singleMin: false, //单笔最小
                            singleMax: false, //单笔最大
                            discountNum: true, //优惠折扣
                            publicTime: true, //公布时间
                            unlockingTime: true, //解锁时间
                            firstRound: false, //首发
                            discount: false, //打折
                            manyTimes: true, //多次购买
                            bkkDiscount: true, //BKK持仓优惠
                            positionLimit: true, //持仓限制
                            turnoverLimit: true, //成交额限制
                            lockLimit: true, //锁仓限制
                            kyc: true, //实名验证
                            area: true, //地区验证
                            formData: true, //表单验证
                            agreementData: true, //协议验证
                            incubatorSynopsis: false,  //简介
                            banner: false, //banner
                            projectDetail: false, //项目详情
                            circulation: false, //流通量
                            tokenType: false,  //代币类型
                            totalIssue: false, //发行总量
                            linked: false, //Linked链接
                            medium: false, //Medium链接
                            twitter: false, //Twitter链接
                            telegram: false, //Telegram链接
                            faq: false, //FAQ链接
                            website: false, //官网链接
                            whitePaper: false //白皮书链接
                        };
                        break;
                    case 2: //进行中
                        this.incubatorDisable = {
                            lang: true, //支持语言
                            incubatorType: true, //活动模式
                            distributionType: true, //分配模式
                            incubatorName: false, //名称
                            incubatorCoin: true, //币种
                            paymentCoin: true, //支付币种
                            discountCoin: true, //优惠币种
                            startTime: true, //开始时间
                            endTime: false, //结束时间
                            totalAmount: true, //总量
                            actualTotalAmount: true, //实际总量
                            price: true, //价格
                            scale: false, //精度
                            singleMin: false, //单笔最小
                            singleMax: false, //单笔最大
                            discountNum: true, //优惠折扣
                            publicTime: true, //公布时间
                            unlockingTime: true, //解锁时间
                            firstRound: false, //首发
                            discount: false, //打折
                            manyTimes: true, //多次购买
                            bkkDiscount: true, //BKK持仓优惠
                            positionLimit: true, //持仓限制
                            turnoverLimit: true, //成交额限制
                            lockLimit: true, //锁仓限制
                            kyc: true, //实名验证
                            area: true, //地区验证
                            formData: true, //表单验证
                            agreementData: true, //协议验证
                            incubatorSynopsis: false,  //简介
                            banner: false, //banner
                            projectDetail: false, //项目详情
                            circulation: false, //流通量
                            tokenType: false,  //代币类型
                            totalIssue: false, //发行总量
                            linked: false, //Linked链接
                            medium: false, //Medium链接
                            twitter: false, //Twitter链接
                            telegram: false, //Telegram链接
                            faq: false, //FAQ链接
                            website: false, //官网链接
                            whitePaper: false //白皮书链
                        };
                        break;
                    case 1: //未开始
                        this.incubatorDisable = {
                            lang: true, //支持语言
                            incubatorType: true, //活动模式
                            distributionType: true, //分配模式
                            incubatorName: false, //名称
                            incubatorCoin: true, //币种
                            paymentCoin: false, //支付币种
                            discountCoin: false, //优惠币种
                            startTime: false, //开始时间
                            endTime: false, //结束时间
                            totalAmount: true, //总量
                            actualTotalAmount: false, //实际总量
                            price: false, //价格
                            scale: false, //精度
                            singleMin: false, //单笔最小
                            singleMax: false, //单笔最大
                            discountNum: false, //优惠折扣
                            publicTime: true, //公布时间
                            unlockingTime: false, //解锁时间
                            firstRound: false, //首发
                            discount: false, //打折
                            manyTimes: false, //多次购买
                            bkkDiscount: false, //BKK持仓优惠
                            positionLimit: true, //持仓限制
                            turnoverLimit: true, //成交额限制
                            lockLimit: false, //锁仓限制
                            kyc: false, //实名验证
                            area: false, //地区验证
                            formData: false, //表单验证
                            agreementData: false, //协议验证
                            incubatorSynopsis: false,  //简介
                            banner: false, //banner
                            projectDetail: false, //项目详情
                            circulation: false, //流通量
                            tokenType: false,  //代币类型
                            totalIssue: false, //发行总量
                            linked: false, //Linked链接
                            medium: false, //Medium链接
                            twitter: false, //Twitter链接
                            telegram: false, //Telegram链接
                            faq: false, //FAQ链接
                            website: false, //官网链接
                            whitePaper: false //白皮书链接
                        };
                        break;
                    case 0: //未上线
                    default:
                        this.incubatorDisable = {
                            lang: false, //支持语言
                            incubatorType: false, //活动模式
                            distributionType: false, //分配模式
                            incubatorName: false, //名称
                            incubatorCoin: false, //币种
                            paymentCoin: false, //支付币种
                            discountCoin: false, //优惠币种
                            startTime: false, //开始时间
                            endTime: false, //结束时间
                            totalAmount: false, //总量
                            actualTotalAmount: false, //实际总量
                            price: false, //价格
                            scale: false, //精度
                            singleMin: false, //单笔最小
                            singleMax: false, //单笔最大
                            discountNum: false, //优惠折扣
                            publicTime: false, //公布时间
                            unlockingTime: false, //解锁时间
                            firstRound: false, //首发
                            discount: false, //打折
                            manyTimes: false, //多次购买
                            bkkDiscount: false, //BKK持仓优惠
                            positionLimit: false, //持仓限制
                            turnoverLimit: false, //成交额限制
                            lockLimit: false, //锁仓限制
                            kyc: false, //实名验证
                            area: false, //地区验证
                            formData: false, //表单验证
                            agreementData: false, //协议验证
                            incubatorSynopsis: false,  //简介
                            banner: false, //banner
                            projectDetail: false, //项目详情
                            circulation: false, //流通量
                            tokenType: false,  //代币类型
                            totalIssue: false, //发行总量
                            linked: false, //Linked链接
                            medium: false, //Medium链接
                            twitter: false, //Twitter链接
                            telegram: false, //Telegram链接
                            faq: false, //FAQ链接
                            website: false, //官网链接
                            whitePaper: false //白皮书链接
                        };
                        break;
                }
            },
            parseData(data) {
                this.incubatorData = {...data};
                this.incubatorData.languageObj = data.lang ? JSON.parse(data.lang) : ["zh"];
                this.incubatorData.incubatorNameObj = data.incubatorName ? JSON.parse(data.incubatorName) : {};
                this.incubatorData.paymentCoinObj = data.paymentCoin ? JSON.parse(data.paymentCoin) : [];
                this.incubatorData.discountCoinObj = data.discountCoin ? JSON.parse(data.discountCoin) : [];
                this.incubatorData.projectDetailObj = data.projectDetail.conditionParams ? JSON.parse(data.projectDetail.conditionParams) : {
                    incubatorSynopsis: {zh: ""},
                    banner: {zh: ""},
                    projectDetail: {zh: ""},
                    circulation: '',
                    tokenType: {zh: ""},
                    totalIssue: '',
                    linked: '',
                    medium: '',
                    twitter: '',
                    telegram: '',
                    faq: '',
                    website: '',
                    whitePaper: ''
                };
                this.incubatorData.bkkDiscountObj = data.bkkDiscount.conditionParams ? JSON.parse(data.bkkDiscount.conditionParams) : [];
                this.incubatorData.areaObj = data.area.conditionParams ? this.getCountryCode(JSON.parse(data.area.conditionParams)) : [];
                this.incubatorData.formDataObj = data.formData.conditionParams ? JSON.parse(data.formData.conditionParams) : {
                    zh: {
                        name: "",
                        desc: "",
                        formData: [{
                            id: (new Date()).getTime(),
                            title: "",
                            must: false,
                            answerType: "",
                            userAnswer: "",
                            correctAnswer: "",
                            option: [{id: (new Date()).getTime(), tag: "", content: ""}]
                        }]
                    }
                };
                this.incubatorData.agreementDataObj = data.agreementData.conditionParams ? JSON.parse(data.agreementData.conditionParams) : {
                    zh: {name: "", content: ""}
                };
                this.$set(this.incubatorData, 'positionLimitObj', data.positionLimit.conditionParams ? JSON.parse(data.positionLimit.conditionParams) : [{
                    id: (new Date()).getTime(),
                    type: "AVERAGE_DAILY_POSITION",
                    coinTypes: "",
                    startTime: "",
                    endTime: "",
                    num: "",
                    dataArry: []
                }]);
                this.$set(this.incubatorData, 'turnoverLimitObj', data.turnoverLimit.conditionParams ? JSON.parse(data.turnoverLimit.conditionParams) : {
                    type: "TURNOVER",
                    pairs: [],
                    name: {zh: ""},
                    startTime: "",
                    endTime: "",
                    num: "",
                    dataArry: []
                });
                this.$set(this.incubatorData, 'lockLimitObj', data.lockLimit.conditionParams ? JSON.parse(data.lockLimit.conditionParams) : []);
                this.$set(this.incubatorData, 'unlockingTimeObj', data.unlockingTime ? JSON.parse(data.unlockingTime) : []);
                this.$forceUpdate();
            },
            closeDialog() {
                this.$refs["incubatorForm"].resetFields();
                this.initData();
                this.setCurrId(null);
                this.toggleCreateDialogVisible(false);
            },
            initData() {
                this.incubatorData = {
                    id: "", //记录id
                    lang: "", //支持语言,数据格式:[zh,..]
                    incubatorType: "SECKILL", //活动模式
                    distributionType: "", //分配模式
                    incubatorName: "", //名称,数据格式:{zh:'',...}
                    incubatorCoin: "", //币种
                    paymentCoin: "", //支付币种,数据格式:[BTC,..]
                    discountCoin: "", //优惠币种,数据格式:[BTC,..]
                    totalAmount: "", //总量
                    actualTotalAmount: "", //实际总量
                    nowAmount: "", //当前总量（已申购）
                    price: "", //价格
                    singleMin: "", //单笔最小
                    singleMax: "", //单笔最大
                    discountNum: "", //优惠折扣
                    state: "", //状态
                    startTime: "", //开始时间
                    endTime: "", //结束时间
                    publicTime: "", //公布时间
                    unlockingTime: "", //解锁时间,数据格式:[{id:1,unlockTime:1000000,scale:0.8},{},..]
                    publishTime: "", //发布时间
                    projectDetail: {
                        id: "",
                        incubatorId: "",
                        conditionType: "PROJECT_DETAIL",
                        conditionStatus: true,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, // projectDetail: {incubatorSynopsis: {}, //简介 banner: {}, //banner projectDetail: {}, //项目详情 circulation: '', //流通量 tokenType: '', //代币类型 totalIssue: '', //发行总量 linked: '', //Linked链接 medium: '', //Medium链接 twitter: '', //Twitter链接 telegram: '', //Telegram链接 faq: '', //FAQ链接 website: '', //官网链接 whitePaper: '' //白皮书链接
                    firstRound: {
                        id: "",
                        incubatorId: "",
                        conditionType: "FIRST_ROUND",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //首发
                    discount: {
                        id: "",
                        incubatorId: "",
                        conditionType: "DISCOUNT",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //打折
                    manyTimes: {
                        id: "",
                        incubatorId: "",
                        conditionType: "MANY_TIMES",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //多次购买
                    bkkDiscount: {
                        id: "",
                        incubatorId: "",
                        conditionType: "BKK_DISCOUNT",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //BKK持仓优惠,数据格式:[{num:2000,payCoinPrice:0.5,discountCounPrice:0.6},{},..]
                    positionLimit: {
                        id: "",
                        incubatorId: "",
                        conditionType: "POSITION_LIMIT",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //持仓限制,数据格式:{type:'',coinTypes:['BTC',..],startTime:10000,endTime:20000,num:1000}
                    turnoverLimit: {
                        id: "",
                        incubatorId: "",
                        conditionType: "TURNOVER_LIMIT",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //成交额限制,数据格式:{type:'',pairs:['BTC_USDT',..],name:'',num:1000}
                    lockLimit: {
                        id: "",
                        incubatorId: "",
                        conditionType: "LOCK_LIMIT",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //锁仓限制,数据格式:[{unlockTime,'',lockCoin:'BTC',lockAmount:2000},....]
                    kyc: {
                        id: "",
                        incubatorId: "",
                        conditionType: "KYC",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //实名验证
                    area: {
                        id: "",
                        incubatorId: "",
                        conditionType: "AREA",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //地区验证,数据格式:[{areaCode:1010,areaName:{zh:'中国'}},...]
                    formData: {
                        id: "",
                        incubatorId: "",
                        conditionType: "FORM_DATA",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //表单验证,数据格式:{name:'',desc:'',formData:[{title:'',must:true,answerType:'',option:[{tag:'',content:''},....]},...]}
                    agreementData: {
                        id: "",
                        incubatorId: "",
                        conditionType: "AGREEMENT_DATA",
                        conditionStatus: false,
                        conditionParams: "",
                        conditionTitle: "",
                        conditionDetail: ""
                    }, //协议验证,数据格式:{name:'',content:''}
                    //下面是对象参数用于json互转
                    languageObj: ["zh"],
                    incubatorNameObj: {},
                    paymentCoinObj: [],
                    discountCoinObj: [],
                    unlockingTimeObj: [{id: (new Date()).getTime(), unlockTime: "", scale: ""}],
                    projectDetailObj: {
                        incubatorSynopsis: {zh: ""},
                        banner: {zh: ""},
                        projectDetail: {zh: ""},
                        circulation: '',
                        tokenType: {zh: ""},
                        totalIssue: '',
                        linked: '',
                        medium: '',
                        twitter: '',
                        telegram: '',
                        faq: '',
                        website: '',
                        whitePaper: ''
                    },
                    bkkDiscountObj: [{id: (new Date()).getTime(), num: "", payCoinPrice: "", discountCounPrice: ""}],
                    positionLimitObj: [{
                        id: (new Date()).getTime(),
                        type: "AVERAGE_DAILY_POSITION",
                        coinTypes: "",
                        startTime: "",
                        endTime: "",
                        num: "",
                        dataArry: []
                    }],
                    turnoverLimitObj: {
                        type: "TURNOVER",
                        pairs: [],
                        name: {zh: ""},
                        startTime: "",
                        endTime: "",
                        num: "",
                        dataArry: []
                    },
                    lockLimitObj: [{id: (new Date()).getTime(), lockCoin: "", lockAmount: "", unlockTime: ""}],
                    areaObj: [],
                    formDataObj: {
                        zh: {
                            name: "",
                            desc: "",
                            formData: [{
                                id: (new Date()).getTime(),
                                title: "",
                                must: false,
                                answerType: "",
                                userAnswer: "",
                                correctAnswer: "",
                                option: [{id: (new Date()).getTime(), tag: "", content: ""}]
                            }]
                        }
                    },
                    agreementDataObj: {
                        zh: {name: "", content: ""}
                    }
                };
                this.incubatorDisable = {
                    lang: false, //支持语言
                    incubatorType: false, //活动模式
                    distributionType: true, //分配模式
                    incubatorName: false, //名称
                    incubatorCoin: false, //币种
                    paymentCoin: false, //支付币种
                    discountCoin: false, //优惠币种
                    startTime: false, //开始时间
                    endTime: false, //结束时间
                    totalAmount: false, //总量
                    actualTotalAmount: false, //实际总量
                    nowAmount: false, //当前总量（已申购）
                    price: false, //价格
                    scale: false, //精度
                    singleMin: false, //单笔最小
                    singleMax: false, //单笔最大
                    discountNum: false, //优惠折扣
                    publicTime: false, //公布时间
                    unlockingTime: false, //解锁时间
                    firstRound: false, //首发
                    discount: false, //打折
                    manyTimes: false, //多次购买
                    bkkDiscount: false, //BKK持仓优惠
                    positionLimit: false, //持仓限制
                    turnoverLimit: false, //成交额限制
                    lockLimit: false, //锁仓限制
                    kyc: false, //实名验证
                    area: false, //地区验证
                    formData: false, //表单验证
                    agreementData: false, //协议验证
                    incubatorSynopsis: false,  //简介
                    banner: false, //banner
                    projectDetail: false, //项目详情
                    circulation: false, //流通量
                    tokenType: false,  //代币类型
                    totalIssue: false, //发行总量
                    linked: false, //Linked链接
                    medium: false, //Medium链接
                    twitter: false, //Twitter链接
                    telegram: false, //Telegram链接
                    faq: false, //FAQ链接
                    website: false, //官网链接
                    whitePaper: false //白皮书链接
                };
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanIncubatorCoinCoin() {
                this.incubatorData.incubatorCoin = '';
                this.$forceUpdate();
            },
            cleanLockLimitCoin(item) {
                item.lockCoin = '';
                this.$forceUpdate();
            },
            deleteUnlockingTimeObj(id) {
                if (this.incubatorData.unlockingTimeObj.length == 1) {
                    this.$message("至少得有一个解锁时间");
                    return;
                }
                for (let i = 0; i < this.incubatorData.unlockingTimeObj.length; i++) {
                    if (this.incubatorData.unlockingTimeObj[i].id == id) {
                        this.incubatorData.unlockingTimeObj.splice(i, 1);
                        this.$forceUpdate();
                        return;
                    }
                }
                this.$forceUpdate();
            },
            addUnlockingTimeObj() {
                this.incubatorData.unlockingTimeObj.push({
                    id: (new Date()).getTime(),
                    unlockTime: "",
                    scale: ""
                });
                this.$forceUpdate();
            },
            deleteBkkDiscountObj(id) {
                if (this.incubatorData.bkkDiscountObj.length == 1) {
                    this.$message("至少得有一个持仓条件");
                    return;
                }
                for (let i = 0; i < this.incubatorData.bkkDiscountObj.length; i++) {
                    if (this.incubatorData.bkkDiscountObj[i].id == id) {
                        this.incubatorData.bkkDiscountObj.splice(i, 1);
                        this.$forceUpdate();
                        return;
                    }
                }
                this.$forceUpdate();
            },
            addBkkDiscountObj() {
                this.incubatorData.bkkDiscountObj.push({
                    id: (new Date()).getTime(),
                    num: "",
                    payCoinPrice: "",
                    discountCounPrice: ""
                });
                this.$forceUpdate();
            },
            deleteLockLimitObj(id) {
                if (this.incubatorData.lockLimitObj.length == 1) {
                    this.$message("至少得有一个锁仓条件");
                    return;
                }
                for (let i = 0; i < this.incubatorData.lockLimitObj.length; i++) {
                    if (this.incubatorData.lockLimitObj[i].id == id) {
                        this.incubatorData.lockLimitObj.splice(i, 1);
                        this.$forceUpdate();
                        return;
                    }
                }
                this.$forceUpdate();
            },
            addLockLimitObj() {
                this.incubatorData.lockLimitObj.push({
                    id: (new Date()).getTime(),
                    lockCoin: "",
                    lockAmount: "",
                    unlockTime: ""
                });
                this.$forceUpdate();
            },
            deletePositionLimitObj(id) {
                if (this.incubatorData.positionLimitObj.length == 1) {
                    this.$message("至少得有一个持仓条件");
                    return;
                }
                for (let i = 0; i < this.incubatorData.positionLimitObj.length; i++) {
                    if (this.incubatorData.positionLimitObj[i].id == id) {
                        this.incubatorData.positionLimitObj.splice(i, 1);
                        this.$forceUpdate();
                        return;
                    }
                }
                this.$forceUpdate();
            },
            addPositionLimitObj() {
                this.incubatorData.positionLimitObj.push({
                    id: (new Date()).getTime(),
                    type: "AVERAGE_DAILY_POSITION",
                    coinTypes: "",
                    startTime: "",
                    endTime: "",
                    num: "",
                    dataArry: []
                });
                this.$forceUpdate();
            },
            getSucessInfo(lang, data) {
                //上传成功
                this.incubatorData.projectDetailObj.projectDetail[lang] = data;
                this.$forceUpdate();
            },
            getSucessInfoBananr(lang, data) {
                //上传成功
                this.incubatorData.projectDetailObj.banner[lang] = data;
                this.$forceUpdate();
            },
            // 实名限制变动
            changeKyc(val) {
                this.incubatorData.kyc.conditionParams = val ? '1' : ''
            }
        },
        created() {

        }
    }
</script>

<style type="text/css" lang="less">
.activity {
    .el-input--prefix .el-input__inner {
        padding-left: 70px !important;
    }

    .el-input--suffix .el-input__inner {
        padding-right: 50px !important;
    }
}

</style>